import React, { useState } from "react";
import {
  Box,
  Button,
  Menu,
  MenuItem,
  ButtonGroup,
  FormLabel,
  Select,
  useTheme,
  Tooltip,
  Stack,
  Typography
} from "@mui/material";
import CircleIcon from '@mui/icons-material/Circle';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import RectangleIcon from '@mui/icons-material/Rectangle';

function EnergiesReportFunctionButtonsRow({
  handleFilterChange,
  piechartOn, uniqueValueNames, uniqueUnitNames, togglePieChart, toggleHeatmap, heatmapOn, activeFilter,
  handleSubReportGroupSelection, subReportGroupSelection, groupSelectionChoices
}) {

  const theme = useTheme();

  const [filterAnchorEl, setFilterAnchorEl] = useState(null);


  const handleFilterMenuOpen = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterMenuClose = () => {
    setFilterAnchorEl(null);
  };


  const handleFilterSelect = (filterValue) => {
    handleFilterChange(filterValue);
    handleFilterMenuClose();
  };

  const heatmapToolTipText = () => {
    return (
      <Stack>
        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
          <Typography sx={{ minWidth: 80 }}> 0 - 20% </Typography>
          <RectangleIcon sx={{ color: theme.palette.heatmap.level1 }} />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
          <Typography sx={{ minWidth: 80 }}>20 - 40% </Typography>
          <RectangleIcon sx={{ color: theme.palette.heatmap.level2 }} />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
          <Typography sx={{ minWidth: 80 }}>40 - 60% </Typography>
          <RectangleIcon sx={{ color: theme.palette.heatmap.level3 }} />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
          <Typography sx={{ minWidth: 80 }}>60 - 80% </Typography>
          <RectangleIcon sx={{ color: theme.palette.heatmap.level4 }} />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
          <Typography sx={{ minWidth: 80 }}>80 - 100% </Typography>
          <RectangleIcon sx={{ color: theme.palette.heatmap.level5 }} />
        </Box>
      </Stack>
    );
  }

  return (
    <Box sx={{ mb: 2, ml: 1 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: 1,
          alignItems: 'center'
        }}
        className="table-buttons"
      >
        <Box >
          <Select
            id="group-select"
            labelId="group-select-label"
            value={subReportGroupSelection}
            onChange={(e) => handleSubReportGroupSelection(e.target.value)}
            fullWidth
            size="small"
          >
            {groupSelectionChoices.map((group, idx) => (
              <MenuItem key={idx} value={group.groupName}>
                {group.groupName}
              </MenuItem>
            ))}
          </Select>
        </Box>


        {/* <Button
          variant="outlined"
          onClick={handleFilterMenuOpen}
          sx={{ mx: 0.5 }}
          color="inherit"
        >
          Filter: {activeFilter?.value}
        </Button> */}
        <Menu
          anchorEl={filterAnchorEl}
          open={Boolean(filterAnchorEl)}
          onClose={handleFilterMenuClose}
        >
          <MenuItem
            onClick={() => handleFilterSelect("all")}
          >
            Show All
          </MenuItem>
          {uniqueValueNames.map((valueName, index) => (
            <MenuItem
              key={index}
              onClick={() => handleFilterSelect(`valueName|${valueName}`)}
            >
              {valueName}
            </MenuItem>
          ))}
          {uniqueUnitNames.map((unitName, index) => (
            <MenuItem
              key={index}
              onClick={() => handleFilterSelect(`unitName|${unitName}`)}
            >
              {unitName}
            </MenuItem>
          ))}
        </Menu>

        <Button
          variant={heatmapOn ? "contained" : "outlined"}
          onClick={() => toggleHeatmap()}
          sx={{ mx: 0.5, color: !heatmapOn && theme.palette.grey[400] }}
        >
          {heatmapOn ? "Heatmap On" : "Heatmap Off"}
        </Button>
        <Tooltip title={heatmapToolTipText()}>
          <InfoOutlineIcon />
        </Tooltip>

        <Button
          variant={piechartOn ? "contained" : "outlined"}
          onClick={() => togglePieChart()}
          sx={{ mx: 0.5, color: !piechartOn && theme.palette.grey[400] }}
        >
          {piechartOn ? "Pie Chart On" : "Pie Chart Off"}
        </Button>

      </Box>
    </Box>
  )
}

export default EnergiesReportFunctionButtonsRow